export default __webpack_public_path__ + "static/media/m_quiz_bg.2b0f73a7.png";